'use client';

import React from 'react';
import { InlineWidget } from 'react-calendly';
import type { Form } from '../../payload-types';
import { useCalendlyTracking } from '../../utilities/hooks/use-calendly-tracking';

const CalendlyEmbed: React.FC<{
  form: Form;
}> = ({ form }) => {
  const url = form.calendly?.eventTypeUrl;

  useCalendlyTracking(form);

  if (!url) { return null; }

  return (
    <InlineWidget
      url={url}
      styles={{ minWidth: '320px', height: '700px' }}
    />
  );
};

export default CalendlyEmbed;
